import React, { useContext } from 'react';
import { Row, Col } from '@sm/wds-react';
import { getAnonCategories } from './helpers';
import { InlineList, InlineListItem } from '../InlineList';
import { SMFooterContext } from '../SMFooterContext';

const AnonFooterLinks = () => {
  const { domain, lang, country, variant } = useContext(SMFooterContext);

  const categories = getAnonCategories(domain, lang, country, variant);
  const margin = variant === 'slim';
  return (
    <>
      {categories.map(category => {
        return (
          <Row key={category[0].title}>
            <Col>
              <InlineList noMargin={margin}>
                {category.map(item => {
                  return (
                    <InlineListItem
                      href={item.url}
                      anchorAttributes={item.anchorAttributes}
                      key={`${item.title}`}
                      isTitle={item.isTitle}
                      lastItem={item.lastItem}
                    >
                      {item.title}
                    </InlineListItem>
                  );
                })}
              </InlineList>
            </Col>
          </Row>
        );
      })}
    </>
  );
};

export default AnonFooterLinks;
